(() => {
  if (customElements.get('quantity-input')) return;

  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onInput = this.onInput.bind(this);
    }

    connectedCallback() {
      if (!this.input || this.dataset.quantityInputBound === 'true') return;

      this.dataset.quantityInputBound = 'true';
      this.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', this.onButtonClick);
      });
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('change', this.onInput);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.querySelectorAll('button').forEach((button) => {
        button.removeEventListener('click', this.onButtonClick);
      });
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('change', this.onInput);
      delete this.dataset.quantityInputBound;
    }

    onButtonClick(event) {
      event.preventDefault();
      if (!this.input || event.currentTarget.disabled) return;

      const previousValue = this.input.value;
      if (event.currentTarget.name === 'plus') {
        this.input.stepUp();
      } else {
        this.input.stepDown();
      }

      this.updateButtons();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    onInput() {
      this.updateButtons();
    }

    updateButtons() {
      if (!this.input) return;

      const value = Number(this.input.value);
      const minAttribute = this.input.getAttribute('min');
      const dataMin = this.input.dataset.min;
      const maxAttribute = this.input.getAttribute('max');
      const min = minAttribute !== null ? Number(minAttribute) : dataMin ? Number(dataMin) : null;
      const max = maxAttribute !== null && maxAttribute !== '' ? Number(maxAttribute) : null;
      const minus = this.querySelector('button[name="minus"]');
      const plus = this.querySelector('button[name="plus"]');

      if (minus && Number.isFinite(min)) minus.disabled = value <= min;
      if (plus && Number.isFinite(max)) plus.disabled = value >= max;
    }
  }

  customElements.define('quantity-input', QuantityInput);
})();